export default "/_next/static/images/a2bae5dd1a5614a9935be7991e64fb82.jpg";